const CurrencySymbol = {
    'EUR': "€",
    'GBP': "£"
}
export default CurrencySymbol;